const { stringify } = require("query-string");
import CompanyService from "@/service/company-service";

export default class ThirdPartyStrategy {
  constructor() {
    this.companyService = new CompanyService();
  }

  async redirect(reservation, guest) {
    const company = this.companyService.getLocalCompany();
    const globalSettings = company.parameters_sc.globalSettings || {};
    const { thirdPartySite } = globalSettings;

    if (thirdPartySite) {
      const qs = this.handleParams(thirdPartySite, reservation, guest);
      window.onbeforeunload = null;
      window.location.href = `${thirdPartySite.url}?${qs}`;
    }
  }

  async redirectWalkIn() {}

  handleParams(thirdPartySite, reservation, guest) {
    let params = {};
    if (thirdPartySite.reservationNumber === true) {
      params.reservationNumber = reservation.reservationNumber;
    }

    if (thirdPartySite.guestName === true) {
      params.guestName = `${guest.name} ${guest.lastName}`;
    }

    if (thirdPartySite.companyId === true) {
      params.companyId = reservation.companyId;
    }

    return stringify(params);
  }
}
